import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { useAccountStore } from "@/stores/account";
import { useAssetStore } from "@/stores/asset";
import { useNotificationStore } from "@/stores/notification";
import { useSnackbarStore } from "@/stores/snackbar";
import localforage from 'localforage'
import axios from 'axios'
import Router from 'vue-router'
import router from './router'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n';

Vue.config.productionTip = false;

(async () => {
  // Localforage
  localforage.config({
    name: 'persistedState'
  });

  // Pinia
  Vue.use(PiniaVuePlugin)
  const pinia = createPinia()

  const accountStore = useAccountStore(pinia);
  const accountStoreValue = await localforage.getItem('accountStore')
  if (accountStoreValue) accountStore.$state = accountStoreValue

  const assetStore = useAssetStore(pinia);
  const assetStoreValue = await localforage.getItem('assetStore')
  if (assetStoreValue) assetStore.$state = assetStoreValue

  const notificationStore = useNotificationStore(pinia);
  const notificationStoreValue = await localforage.getItem('notificationStore')
  if (notificationStoreValue) notificationStore.$state = notificationStoreValue

  const snackbarStore = useSnackbarStore();

  // Router
  Vue.use(Router)

  // Localisation
  Vue.use(VueI18n);

  const loadLocaleMessages = () => {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = locales(key)
      }
    })
    return messages
  }

  const i18n = new VueI18n({
    locale: navigator.language.split("-")[0],
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
  });

  // Axios
  Vue.prototype.$http = axios;
  Vue.prototype.$http.defaults.withCredentials = true;

  const csrfToken = localStorage.getItem("csrfToken")
  if (csrfToken) {
    Vue.prototype.$http.defaults.headers.common["x-csrf-token"] = csrfToken
  }

  Vue.prototype.$http.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (error.code === "ERR_NETWORK") {
      snackbarStore.text = i18n.t("noConnection");
      snackbarStore.snackbar = true;
    }
    if (error.response.status == 401) {
      accountStore.account = {}
      router.push('/login')
    }
    return Promise.reject(error);
  })

  // Vue
  new Vue({
    pinia,
    router,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})();